angular.module("qbePortal").controller("DeclineController", [
	"$scope",
	"$state",
	"$stateParams",
	"$sce",
	"$filter",
	"labelService",
	"Util",
	"storage",
	"MODULE_INFO",
	function(
		$scope,
		$state,
		$stateParams,
		$sce,
		$filter,
		labelService,
		util,
		storage,
		MODULE_INFO
	) {
		var $ctrl = this;
		$ctrl.declineMessages = [];

		$ctrl.initPage = function() {
			util.dispatchCustomEvent("register-labels");
			getDeclineCodes();
			var declineType = $state.current.name;
			$ctrl.title = labelService.getSectionLabelFor(declineType);
			$ctrl.descriptionHTML = labelService.getSectionDescriptionFor(
				declineType
			);
			$ctrl.nextStep = processWildCard(
				labelService.getLabelFor("nextStep"),
				getStartRoute()
			);
			storage.clear();
		};

		// gdd-3756 - unauthenticated payments decline
		$ctrl.initPayBills = function() {
			util.dispatchCustomEvent("register-labels");
			storage.clear();
			if (qbe.fieldLabels) {
				$ctrl.headBar = qbe.fieldLabels.headBar;
				$ctrl.phoneNumber = qbe.fieldLabels.enterPaymentRef.phone;
				$ctrl.paymentDeclineLabel =
					qbe.fieldLabels.paymentDecline.title;
				$ctrl.paymentDeclineDescription =
					qbe.fieldLabels.paymentDecline.description;
				$ctrl.paymentDeclineSubDescription =
					qbe.fieldLabels.paymentDecline.subDescription;
				$ctrl.chatAgentLabel = qbe.fieldLabels.buttonLabel.chatAgent;
				$ctrl.callAgentLabel = qbe.fieldLabels.buttonLabel.callAgent;
				$ctrl.referenceNumber = $stateParams.referenceNumber;

				var footHeight = $(".footer").outerHeight(),
					windowHeight = $(window).height(),
					documentHeight = $(document).height(),
					minHeight;

				if ($(window).outerWidth() >= 768) {
					if (documentHeight > windowHeight) {
						minHeight = documentHeight - footHeight - 5;
					} else {
						minHeight = windowHeight - footHeight - 5;
					}

					$(".col1").css("min-height", minHeight + "px");
				} else {
					$(".col1").css("min-height", "auto");
				}
			}
		};

		/**
		 * Get decline codes - typeCodes submitted from product controllers
		 * @param {none}
		 * @return {none}
		 */
		function getDeclineCodes() {
			var codes = $stateParams.declineCodes; // get typeCodes from $stateParams

			if ($state.current.name === 'embargo') {
				var message = "Potential or current weather conditions in the area";
				$ctrl.declineMessages.push({
					message: message
				});
			}
			// loop through array and lookup labels
			else if (!util.isUndefinedOrNull(codes) && codes !== "null") {
				angular.forEach(codes, function(value) {
					var message = $ctrl.lookupLabel([value]);

					// get default message in case typeCode is not setup
					if (util.isUndefinedOrNull(message)) {
						message = $ctrl.lookupLabel("default");
					}

					if (value === "ccPaymentError") {
						message += " " + $stateParams.declineType;
					}

					$ctrl.declineMessages.push({
						message: message
					});
				});
			} else {
				$ctrl.declineMessages.push({
					message: "the information provided in this quote"
				});

				console.log($ctrl.declineMessages);
			}
		}

		/**
		 * Start route - create URL for step 1 of all products
		 * @param {none}
		 * @return {string} - Step 1 URL
		 */
		function getStartRoute() {
			var routeName = MODULE_INFO.startRouteName.split(".");
			var currentURL = window.location.href.split("/");

			currentURL[currentURL.length - 1] = routeName[1];
			var newURL =
				'<a target="_self" href="' +
				currentURL.join("/") +
				'">new quote</a>';
			var homeURL =
				'<a target="_self" href="' +
				window.location.origin +
				'/au">QBE Homepage</a>';

			return [newURL, homeURL];
		}

		/**
		 * Process wildcard - handle multiple wildcards to be replaced
		 * @param {string} - target string
		 * @param {array} - array of string
		 * @return {string} - destination string
		 */
		function processWildCard(targetString, wildcardValue) {
			if (
				typeof wildcardValue == "string" ||
				typeof wildcardValue == "undefined"
			) {
				targetString = util.stringFormat(targetString, wildcardValue);
			} else {
				var argArr = [];
				argArr.push(targetString);
				argArr = argArr.concat(wildcardValue);
				targetString = util.stringFormat.apply(null, argArr);
			}
			return targetString;
		}

		/**
		 * Label lookup - get labels from global options
		 * @param {string} - fieldName
		 * @return {string} - labels
		 */
		$ctrl.lookupLabel = function(fieldName) {
			return labelService.getGlobalOptionLabel(
				"declineConfiguration",
				fieldName
			);
		};

		$ctrl.getProduct = function() {
			return MODULE_INFO.id;
		};

		$ctrl.getLabelFor = function(fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		$scope.$root.$broadcast("loading-animation-end");
	}
]);
